import React, { useContext, useEffect } from 'react'
import { PrinterContext } from '@/store'
import IconCheckmarkCircle from '@veneer/core/dist/scripts/icons/icon_checkmark_circle'

import classes from './PrinterView.module.scss'
import { usePrinterDetailsApp } from '@/hooks/usePrinterDetailsApp'
import { Logger } from '@/utils/Logger'

export function PrinterView({ checkmark }) {
  const { printerImage, modelName } = useContext(PrinterContext)
  const { handlePrinterDetailsApp } = usePrinterDetailsApp()

  useEffect(() => {
    handlePrinterDetailsApp().catch((error) => {
      Logger.error('Error trying to get printer details printer', error)
    })
  }, [])

  return (
    <div className={classes.printerViewContainer}>
      <div className={classes.imageContainer}>
        {checkmark && (
          <IconCheckmarkCircle
            filled
            size={54}
            color="hunterGreen7"
            className={classes.iconCheckmark}
          />
        )}
        <img width={292} src={printerImage} alt="Printer model image" />
      </div>
      <h6 className={classes.modelName}>{modelName}</h6>
    </div>
  )
}
